import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  MapillaryImportSequence,
  MapillaryQuerySequences,
  MapillarySequence,
} from "../models/Mapillary";

const prefix = "/mapillary";

export const MapillaryApi = {
  querySequences: async (body: MapillaryQuerySequences) =>
    await jwtAuthAxios().post<MapillarySequence[]>(
      `${prefix}/query-sequences`,
      body
    ),

  importSequence: async (body: MapillaryImportSequence) =>
    await jwtAuthAxios().post<string>(`${prefix}/import-sequence`, body),
};
